const services = [
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20evoking%20system%20architecture%20diagrams%20using%20muted%20earth%20tones%20terracotta%20beige%20cream%20and%20precise%20black%20lines%20on%20light%20background%20minimalist%20design%20reminiscent%20of%20technical%20blueprints%20without%20depicting%20any%20specific%20software%20interface&width=600&height=600&seq=analitikos-svc-01&orientation=squarish",
    title: "System Architecture",
    description: "Designing robust, scalable architectures that form the foundation of reliable digital platforms built for long-term evolution.",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20geometric%20pattern%20with%20concentric%20circles%20and%20radiating%20lines%20in%20warm%20ochre%20and%20charcoal%20tones%20on%20cream%20background%20suggesting%20performance%20optimization%20and%20speed%20through%20minimal%20technical%20diagram%20aesthetic&width=600&height=600&seq=analitikos-svc-02&orientation=squarish",
    title: "Performance Optimization",
    description: "Optimizing system responsiveness and efficiency through data-driven analysis and continuous refinement of core processes.",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20modular%20grid%20composition%20with%20interconnected%20nodes%20and%20clean%20lines%20in%20muted%20sage%20green%20and%20beige%20tones%20on%20light%20background%20evoking%20scalable%20distributed%20systems%20architecture%20without%20specific%20product%20references&width=600&height=600&seq=analitikos-svc-03&orientation=squarish",
    title: "Scalable Systems",
    description: "Building systems that grow seamlessly with demand while maintaining stability, consistency, and operational reliability.",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20flowing%20organic%20curves%20intersecting%20with%20precise%20geometric%20lines%20in%20warm%20sand%20and%20charcoal%20tones%20on%20cream%20background%20representing%20human%20centered%20design%20principles%20without%20depicting%20people%20or%20interfaces&width=600&height=600&seq=analitikos-svc-04&orientation=squarish",
    title: "User-Centered Design",
    description: "Crafting intuitive experiences through careful attention to usability, interaction patterns, and thoughtful interface design.",
  },
];

export default function ServicesSection() {
  return (
    <section className="relative bg-foreground-950 py-24 md:py-32 px-8 md:px-12 overflow-hidden">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end gap-8 lg:gap-16 mb-20">
          <div className="shrink-0">
            <span className="inline-block px-4 py-1.5 rounded-full border border-white/20 text-white text-xs uppercase tracking-widest font-medium">
              Services
            </span>
          </div>
          <div>
            <h2 className="text-4xl md:text-5xl lg:text-[56px] font-bold text-white leading-[1.1]">
              Technical
              <br />
              Capabilities
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className="bg-background-100 rounded-2xl overflow-hidden group"
            >
              <div className="aspect-square w-full overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-6">
                <h3 className="text-base font-semibold text-foreground-900 mb-2">
                  {service.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}